// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__Ve0FR","header":"ReportDetails_header__359Fl","title":"ReportDetails_title__36I6H","left":"ReportDetails_left__2ARLc"};